import { render } from "./LessonComponent.vue?vue&type=template&id=8a78962a&scoped=true"
import script from "./LessonComponent.vue?vue&type=script&lang=js"
export * from "./LessonComponent.vue?vue&type=script&lang=js"

import "./LessonComponent.vue?vue&type=style&index=0&id=8a78962a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a78962a"]])

export default __exports__